import React from 'react';
import { Container } from '@mui/material';
import {
  ThemeProvider,
  styled,
  useTheme,
  createTheme,
} from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: ['Whitney Book'].join(','),
    h1: {
      fontFamily: 'Whitney Bold',
    },
    button: {
      fontFamily: 'Whitney Bold',
    },
  },
  palette: {
    primary: {
      main: '#006c9c',
      dark: '#053e85',
    },
    secondary: {
      main: '#888',
    },
    neutral: {
      main: '#64748B',
      contrastText: '#fff',
    },
  },
});

export function PageLayout({ children }) {
  return (
    <Container
      fixed
      maxWidth="md"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {children}
    </Container>
  );
}
